// TODO: Put URL in configuration

const loginPageUrlProd = 'https://app.mytalentplug.com'
const loginPageUrlPprod = 'https://preprod-app.mytalentplug.com'
const loginPageUrlLocal = 'http://localhost:60149/'

export { loginPageUrlProd, loginPageUrlPprod, loginPageUrlLocal }
